import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/solanova/Logo";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="border-t hairline bg-[var(--sol-bg)]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="flex flex-col md:flex-row gap-10 md:items-end md:justify-between">
          <div>
            <Logo size="md" />
            <p className="font-body text-white/45 mt-6 max-w-sm text-sm leading-relaxed">
              Photovoltaik · Batteriespeicher · Wallbox · Beratung.
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-8 text-sm">
            <div>
              <p className="eyebrow mb-4">Leistungen</p>
              <ul className="space-y-2 text-white/65 font-body">
                <li>Photovoltaik</li>
                <li>Batteriespeicher</li>
                <li>Wallbox</li>
                <li>Beratung</li>
              </ul>
            </div>
            <div>
              <p className="eyebrow mb-4">Unternehmen</p>
              <ul className="space-y-2 text-white/65 font-body">
                <li>Über uns</li>
                <li>Projekte</li>
                <li>Kontakt</li>
              </ul>
            </div>
            <div>
              <p className="eyebrow mb-4">Kontakt</p>
              <ul className="space-y-2 text-white/65 font-body">
                <li>Solanova GmbH</li>
                <li>Vogelherd 5</li>
                <li>9225 Wilen-Gottshaus</li>
                <li>info@solanova.ch</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t hairline flex flex-col md:flex-row gap-4 md:items-center md:justify-between text-xs text-white/35 font-body">
          <span>© {year} Solanova GmbH. Alle Rechte vorbehalten.</span>
          <div className="flex items-center gap-6">
            <Link
              to="/impressum"
              data-testid="footer-link-impressum"
              className="hover:text-white transition-colors"
            >
              Impressum
            </Link>
            <Link
              to="/datenschutz"
              data-testid="footer-link-datenschutz"
              className="hover:text-white transition-colors"
            >
              Datenschutz
            </Link>
            <Link
              to="/agb"
              data-testid="footer-link-agb"
              className="hover:text-white transition-colors"
            >
              AGB
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
